'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var align = _ref.align,
      direction = _ref.direction,
      justify = _ref.justify,
      spacing = _ref.spacing,
      styles = _ref.styles;
  var calculateSpacing = _ref2.calculateSpacing,
      justifyContent = _ref2.justifyContent;
  return {
    root: (0, _merge2.default)(_extends({
      display: 'flex',
      minWidth: '100%',
      flexWrap: 'wrap',
      alignItems: align,
      direction: direction
    }, justifyContent(justify), calculateSpacing(spacing, 'margin', { multiplier: -1 }), {

      '& > *': _extends({}, calculateSpacing(spacing, 'padding')),

      '& > *:empty': {
        padding: 0
      }
    }), styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/grid/styles.js
// module id = 836
// module chunks = 0